import api from '../api';
import AdminFormDataActions from 'actions/admin/AdminFormDataActions';

const AdminFormDataSource = {
  fetchFormData: {
    remote(state, accountId, args) {
      return api.get(`/account/${accountId}/form-data`, {
        baseURL: '/apiv2/admin',
      });
    },
    success: AdminFormDataActions.fetchFormDataSuccess,
    error: AdminFormDataActions.fetchFormDataError,
  },
};

export default AdminFormDataSource;
